import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface SectionWrapperProps {
  children: React.ReactNode;
  bgColor?: string;
  id?: string;
  className?: string;
  noPadding?: boolean;
}
export function SectionWrapper({
  children,
  bgColor = 'bg-brand-black',
  id,
  className = '',
  noPadding = false
}: SectionWrapperProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section id={id} className={`${bgColor} ${className}`} data-id="element-223">
      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 40
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className={noPadding ? '' : 'max-w-4xl mx-auto px-6 py-16 md:py-24'} data-id="element-224">
        {children}
      </motion.div>
    </section>;
}